import React, { useState } from 'react';
import { Button, Text, VStack } from '@chakra-ui/react';
import { sendEmailOrder } from '../api';

function SendEmailButton({ orderId, text }) {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const send = async (_orderId) => {
    setError('')
    setSuccess(false)
    setIsLoading(true);
    const res = await sendEmailOrder(_orderId);
    setIsLoading(false);
    // console.log(res)
    if (!res.success) {
      setError(res.message);
      return;
    }
    setSuccess(true);
  };

  if (success) return <Text color='gold'>Email inviata!</Text>;

  const label = text || 'Invia Mail'

  return (
    <VStack>
      <Button
        isLoading={isLoading}
        onClick={() => {
          send(orderId);
        }}
      >
        {label}
      </Button>
      {error && <Text color='tomato'>{error}</Text>}
    </VStack>
  );
}

export default SendEmailButton;
